import React from "react";
import Typography from "@material-ui/core/Typography";
import useUserName from "../hooks/useUserName";
import { Button } from "devextreme-react";
import { useDispatch } from "react-redux";
import { logoutUser } from "../redux/slices/userSlice";

const ProfilePage = () => {
  const name = useUserName();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  return (
    <div>
      <Typography paragraph>User: {name}</Typography>
      <Button
        icon="export"
        type="danger"
        text="Logout"
        width="200"
        onClick={handleLogout}
      />
    </div>
  );
};

export default ProfilePage;
